import React from 'react'
import MediaQuery from 'react-responsive'
import { compact, omit } from 'lodash'

import { Link } from 'core'
import { Select } from 'form'
import { Grid, GridItem } from 'layout'
import { FILTER_OPTIONS } from 'event-taxonomy'

import css from './style.scss'
import { breakpoints } from 'styles'

const { phabletMax, phabletMaxPlusOne } = breakpoints

// Keeps the rest of the query (view, month) while swapping the type.
const queryFor = (query, value) =>
  value ? { ...query, type: value } : omit(query, ['type'])

const EventsFilters = ({ activeType, query, onDropdownChange }) => {
  const tabs = (
    <div className={css.wrapper}>
      <Grid noGutter>
        {FILTER_OPTIONS.map(option => {
          const isActive = (option.value || null) === (activeType || null)

          return (
            <GridItem col='1/5' key={option.value || 'all'}>
              <Link to={{ pathname: '/events', query: queryFor(query, option.value) }}>
                <div
                  className={compact([css.tab, isActive ? css.active : null]).join(' ')}
                  aria-current={isActive ? 'page' : null}
                >
                  <span>{option.label}</span>
                </div>
              </Link>
            </GridItem>
          )
        })}
      </Grid>
    </div>
  )

  const dropdown = (
    <div className={css.dropdownWrapper}>
      <Select
        grey
        name='type'
        aria-label='Filter by event type'
        options={FILTER_OPTIONS
          .filter(option => option.value)
          .map(option => ({ name: option.label, value: option.value }))}
        input={{ value: activeType, onChange: onDropdownChange }}
        placeholder='All Events'
      />
    </div>
  )

  return (
    <div>
      <MediaQuery minWidth={phabletMaxPlusOne}>{tabs}</MediaQuery>
      <MediaQuery maxWidth={phabletMax}>{dropdown}</MediaQuery>
    </div>
  )
}

EventsFilters.propTypes = {
  activeType: React.PropTypes.string,
  query: React.PropTypes.object,
  onDropdownChange: React.PropTypes.func.isRequired
}

EventsFilters.defaultProps = {
  query: {}
}

export default EventsFilters
